export default [
    {
        path: "/single-window",
        component: () => import("@/layouts/SingleWindowLayout.vue"),
        children: [
            {
                // Home de la Ventanilla Única: <url según ambiente>/single-window
                path: "",
                component: () => import("@/feature/single_window/home/presentation/views/home_single_window.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Ventanilla Superfinanciera' },
                    ],
                },
            },
            {
                path: "check-status-procedure",
                component: () => import("@/feature/single_window/check_status_procedure/presentation/views/process_tracking.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Consultar estado del trámite' },
                    ],
                },
            },
            {
                path: "check-status-procedure/detail",
                component: () => import("@/feature/single_window/check_status_procedure/presentation/views/process_detail.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Consultar estado del trámite', link: '/single-window/check-status-procedure' },
                        { label: 'Detalle' },
                    ],
                },
            },
            {
                path: "add-info-request",
                component: () => import("@/feature/single_window/add_info_request/presentation/views/add_info.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Agregar información' },
                    ],
                },
            },
            {
                // Flujo "Crear trámite". Primer paso (pregunta orientadora inicial):
                // <url según ambiente>/single-window/create-procedure
                path: "create-procedure",
                component: () => import("@/feature/single_window/create_procedure/presentation/views/question_relates_procedure.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Crear trámite' },
                    ],
                },
            },
            {
                // Flujo "Crear trámite". Cada vista del flujo se registra como
                // una ruta bajo create-procedure/*.
                path: "create-procedure/question-sfc-procedure",
                component: () => import("@/feature/single_window/create_procedure/presentation/views/question_sfc_procedure.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Crear trámite' },
                    ],
                },
            },
                {                 
                path: "create-procedure/question-type-fill",
                component: () => import("@/feature/single_window/create_procedure/presentation/views/question_type_fill.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Crear trámite' },
                    ],
                },
            },
            {
                // Flujo "Crear trámite" — opciones para entidad vigilada:
                // <url según ambiente>/single-window/create-procedure/question-ev-procedure
                path: "create-procedure/question-ev-procedure",
                component: () => import("@/feature/single_window/create_procedure/presentation/views/question_ev_procedure.vue"),
                meta: {
                    breadcrumb: [
                        { label: 'Inicio', link: '/' },
                        { label: 'Crear trámite' },
                    ],
                },
            },
        ],
    },
];
